import React from 'react';
import classnames from 'classnames';
import styles from './CreateFileModal.module.scss';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { ActivityAssociation, File } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { FileFormFields } from 'v2/utils/drmFileUtils';
import FormModal from 'v2/common/FormModal/FormModal';
import FileForm from './FileForm';
import { buildFormData } from 'v2/utils/formUtils';

interface CreateFileModalProps {
  defaultAssociations?: ActivityAssociation[];
  onClose: () => void;
}

const CreateFileModal = ({
  defaultAssociations = [],
  onClose,
}: CreateFileModalProps) => {
  const formContext = useForm<FileFormFields>({
    mode: 'onChange',
  });

  const { mutate, isLoading } = useMutation(
    async (data: FileFormFields) => {
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      const formData = new FormData();
      buildFormData(formData, {
        ...data,
        relationships: data.relationships.filter(
          (assoc) => assoc.selected !== false
        ),
      });
      return await restFactory.post<File>(
        `/dj/api/v1/file/`,
        formData,
        headers
      );
    },
    {
      onSuccess: () => {
        onClose();
        toast.success('File saved.');
      },
      onError: () => {
        toast.error('Error saving file.');
      },
    }
  );

  const handleOnSubmit = (data: FileFormFields) => {
    mutate(data);
  };

  return (
    <FormModal
      title="Add a File"
      onClose={onClose}
      onSubmit={handleOnSubmit}
      isLoading={isLoading}
      formContext={formContext}
      className={classnames(styles.viewModals)}
    >
      <FileForm
        isLoading={isLoading}
        defaultAssociations={defaultAssociations}
      />
    </FormModal>
  );
};

export default CreateFileModal;
